import type { SourceSetQuery } from "./SourceSetQuery.js";
import { querySizeMappings } from "./querySizeMappings.js";

export function parseSourceSet(query: SourceSetQuery): string {
	const size = querySizeMappings[query.slice(1) as keyof typeof querySizeMappings];
	return `(width ${query.startsWith(">") ? ">=" : "<"} ${size}rem)`;
}
